import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTrackClosedVersionsTray } from "@air/analytics";
import { memo, useMemo } from "react";
import { useCanAnnotateCentralizedPublicClip } from "~/components/Annotations/hooks/useCanAnnotateCentralizedPublicClip";
import { ToggleAnnotationsButton } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/components/ToggleAnnotationsButton";
import { EditAnnotationsButton } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/EditAnnotationsButton";
import { AssetModalFooter } from "~/components/AssetModal/AssetModalFooter/AssetModalFooter";
import { ToggleVersionsPanelButton } from "~/components/AssetModal/AssetModalFooter/VersionList/components/ToggleVersionsPanelButton";
import { VersionListHeader } from "~/components/AssetModal/AssetModalFooter/VersionList/components/VersionListHeader";
import { useVersionsPanelState } from "~/components/AssetModal/AssetModalFooter/VersionList/hooks/useVersionsPanelState";
import { VersionList } from "~/components/AssetModal/AssetModalFooter/VersionList/VersionList";
import { PublicVersionsListContent } from "~/components/PublicAssetModal/components/PublicVersionsListContent/PublicVersionsListContent";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { canSeeAssetVersions } from "~/utils/permissions/assetPermissions";
export const PublicAssetModalFooter = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canViewAssetVersions = canSeeAssetVersions(permissions);
    const { trackClosedVersionsTray } = useTrackClosedVersionsTray();
    const { isVersionsPanelOpen, setVersionsPanelOpen } = useVersionsPanelState();
    const { canSeeClipAnnotation, canEditAnnotation } = useCanAnnotateCentralizedPublicClip();
    const closePanel = ()=>{
        trackClosedVersionsTray();
    };
    const AnnotateButton = useMemo(()=>{
        if (canEditAnnotation) {
            return /*#__PURE__*/ _jsx(EditAnnotationsButton, {
                className: "absolute right-4"
            });
        } else if (canSeeClipAnnotation) {
            return /*#__PURE__*/ _jsx(ToggleAnnotationsButton, {
                className: "absolute right-4"
            });
        }
    }, [
        canEditAnnotation,
        canSeeClipAnnotation
    ]);
    return /*#__PURE__*/ _jsx(AssetModalFooter, {
        header: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                canViewAssetVersions && /*#__PURE__*/ _jsx(ToggleVersionsPanelButton, {
                    isVersionsOpen: isVersionsPanelOpen,
                    setIsVersionsOpen: setVersionsPanelOpen
                }),
                AnnotateButton
            ]
        }),
        className: isVersionsPanelOpen ? "h-[280px]" : "h-16",
        children: canViewAssetVersions && /*#__PURE__*/ _jsx(VersionList, {
            isOpen: isVersionsPanelOpen,
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(VersionListHeader, {
                        closePanel: closePanel
                    }),
                    /*#__PURE__*/ _jsx(PublicVersionsListContent, {})
                ]
            })
        })
    });
});
PublicAssetModalFooter.displayName = "PublicAssetModalFooter";
